/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable react/react-in-jsx-scope */
import { Grid, IconButton } from "@material-ui/core";
import useText from "constants/text";
import { useCourseContext } from "contexts/CourseContext";
import { IPickup, modalType } from "domains/Course/data/types";
import { NewAddress, ProductInfo, useCourseFormStyle } from "domains/Course/style";
import { isDateValid } from "domains/Course/utils";
import { EditIcon } from "icons";
import { memo, useMemo, useState } from "react";
import { TextField } from "ui/TextField";
import { formatDate, truncateString } from "utils";
import { AddItem } from "../AddItem";
import { Divider } from "../Divider";
import AddProducModal from "../modals/AddProducModal";
import AddressModal from "../modals/AddressModal";

const Pickup = ({ pickupIndex, isEdit }: IPickup) => {
  const { pickups, isSubmitted, addProductToPickup, editPickup } = useCourseContext();
  const { text } = useText();
  const classes = useCourseFormStyle();
  const [isDelay, setIsDelay] = useState<boolean>(true);

  const [openModal, setOpenModal] = useState({
    addProduct: false,
    selecetAddress: false,
  });

  const toggleModal = (modal: string) => {
    setOpenModal({ ...openModal, [modal]: !openModal[modal] });
  };

  const getValidDelay = (value: string) =>
    !isTime()
      ? formatDate(value, "yyyy-MM-dd")
      : `${formatDate(value, "yyyy-MM-dd")} / ${pickups[pickupIndex]?.delay?.split("/")[1]?.trim()}`;

  const formHandler = {
    handleDelay: (e: any) => {
      editPickup(pickupIndex, "delay", getValidDelay(e.target.value));
    },
    handleTime: (event: any) => {
      const delay = pickups[pickupIndex]?.delay?.split("/")[0].trim();
      editPickup(pickupIndex, "delay", `${delay}${` / ${event?.target?.value}`}`);
      setIsDelay(false);
    },
    handleProductName: (productIndex: number) => (event: any) => {
      editPickup(pickupIndex, event?.target?.name, event?.target?.value, productIndex);
    },
    handleQuantity: (productIndex: number) => (event: any) => {
      editPickup(pickupIndex, event?.target?.name, event?.target?.value, productIndex);
    },
  };

  const isLastProductFieldEmpty = (): boolean =>
    !!pickups[pickupIndex].products[pickups[pickupIndex].products?.length - 1]?.name;

  const toggleAddproduct = () => {
    toggleModal("addProduct");

    if (!isLastProductFieldEmpty()) {
      return;
    }
    if (!openModal.addProduct && !isEdit) {
      addProductToPickup(pickupIndex);
    }
  };

  const togglSelectAddress = () => {
    toggleModal("selecetAddress");
  };

  const handleIsDelay = () => {
    setIsDelay(!isDelay);
  };
  const isTime = () => pickups[pickupIndex]?.delay?.includes("/");

  const onHandleDelayEdit = () => setIsDelay(false);

  const countValidProduct = useMemo(
    () => pickups[pickupIndex]?.products?.filter((item: any) => item?.name !== null)?.length,
    [pickups, pickupIndex]
  );

  return (
    <Grid>
      <Grid container spacing={4}>
        <Grid item xs={12}>
          {pickups[pickupIndex]?.address ? (
            <Grid item xs={12}>
              <>
                <TextField
                  required
                  label={text.all.pickup_address}
                  variant="outlined"
                  value={`${truncateString(pickups[pickupIndex]?.address?.address?.address)}, ${pickups[pickupIndex]?.address?.firstname
                    }, ${pickups[pickupIndex]?.address?.lastname}, ${pickups[pickupIndex]?.address?.phoneNumber || pickups[pickupIndex]?.address?.phone_number
                    }`}
                  name="address"
                  fullWidth
                />
                <IconButton onClick={togglSelectAddress} className={classes.editAddress}>
                  <EditIcon width={20} />
                </IconButton>
              </>
            </Grid>
          ) : (
            <NewAddress
              error={isSubmitted && pickups[pickupIndex]?.address?.address?.address === undefined}
              onClick={togglSelectAddress}
            >
              {text.all.select_pickup_address}
            </NewAddress>
          )}
        </Grid>

        {pickups[pickupIndex]?.delay?.split("/")[1]?.trim() && (
          <Grid item xs={12}>
            <TextField
              variant="outlined"
              label={text.all.delay}
              name="product"
              fullWidth
              error={isSubmitted && !pickups[pickupIndex]?.delay?.split("/")[1]?.trim()}
              className={classes.disabled}
              placeholder="Product description"
              value={pickups[pickupIndex]?.delay}
            />
            <IconButton onClick={handleIsDelay} className={classes.editAddress}>
              <EditIcon width={20} />
            </IconButton>
          </Grid>
        )}

        {isDelay && (
          <Grid item container spacing={4}>
            <Grid item xs={12}>
              <Divider prefix={text.all.delay} />
            </Grid>

            <Grid item xs={9}>
              <TextField
                fullWidth
                id="date"
                name="delay"
                label={text.all.date}
                type="date"
                value={pickups[pickupIndex]?.delay?.split("/")[0]?.trim()}
                onChange={formHandler.handleDelay}
                className={classes.textField}
                defaultValue={pickups[pickupIndex]?.delay?.split("/")[0]?.trim()}
                onBlur={onHandleDelayEdit}
                InputLabelProps={{
                  shrink: true,
                }}
                error={
                  (isSubmitted && !pickups[pickupIndex]?.delay?.split("/")[0]?.trim()) ||
                  !isDateValid(pickups[pickupIndex]?.delay?.split("/")[0])
                }
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                fullWidth
                label={text.all.time}
                type="time"
                defaultValue={pickups[pickupIndex]?.delay?.split("/")[1]?.trim()}
                onChange={formHandler.handleTime}
                className={classes.textField}
                error={isSubmitted && !pickups[pickupIndex]?.delay?.split("/")[1]?.trim()}
                disabled={!pickups[pickupIndex]?.delay}
              />
            </Grid>
          </Grid>
        )}

        {countValidProduct < 2 ? (
          <Grid item container spacing={4}>
            <Grid item xs={8}>
              <TextField
                required
                variant="outlined"
                label={text.course.product_pickup}
                name="name"
                fullWidth
                placeholder={text.all.product_description}
                value={pickups[pickupIndex]?.products[0]?.name}
                onChange={formHandler.handleProductName(0)}
                error={isSubmitted && !pickups[pickupIndex]?.products[0]?.name}
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                required
                variant="outlined"
                label="quantity"
                name="quantity"
                fullWidth
                placeholder={text.all.quantity}
                value={pickups[pickupIndex]?.products[0]?.quantity}
                onChange={formHandler.handleQuantity(0)}
                type="number"
                InputProps={{ inputProps: { min: 1 } }}
              />
            </Grid>
          </Grid>
        ) : (
          <Grid item xs={12}>
            <ProductInfo onClick={toggleAddproduct}>
              <span className="info">{text.all.product_to_pick}</span>
              <small className="counter">{countValidProduct}</small>
            </ProductInfo>
          </Grid>
        )}

        <Grid item xs={12}>
          <AddItem title={text.course.add_product} onClick={toggleAddproduct} />
        </Grid>
      </Grid>
      <AddProducModal onClose={toggleAddproduct} itemIndex={pickupIndex} open={openModal?.addProduct} />
      <AddressModal
        onClose={togglSelectAddress}
        modalType={modalType.PICKUP_MODAL}
        itemIndex={pickupIndex}
        open={openModal.selecetAddress}
        isPickup
      />
    </Grid>
  );
};

export default memo(Pickup);
